// extracted by mini-css-extract-plugin
export default {"container":"proof-received_container__ykEZ9","greenButton":"proof-received_greenButton__eq7WP"};